// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_eK","advertDetailHeaderLocation__value":"c-m_eL"};